// extracted by mini-css-extract-plugin
export default {"lineBreaker":"asspLayoutAskWorkedTime_lineBreaker__qMvzJ"};